import React, { useEffect, useState } from 'react';

import Layout from '../../components/layout';
import SEO from '../../components/seo';

import { BlogItem, BlogItemResponse } from '../../interfaces/blog';

const NewsItemPage = (props: { id: string }) => {
  const [selectedBlogItem, setSelectedBlogItem] = useState<BlogItem | null>(null);

  useEffect(() => {
    const getBlogItem = (id: string) => {
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');

      const graphql = JSON.stringify({
        query: `query Blog {
			  blog(where: {id: "${id}"}) {
				date
				id
				title
				mainImage {
				  url
				}
				rich {
				  html
				}
			  }
			}
			`,
        variables: {},
      });

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: graphql,
      };

      fetch('https://api-eu-west-2.hygraph.com/v2/clgmiysfd553901t2h4wj8nro/master', requestOptions)
        .then((response) => response.json())
        .then((resultData: BlogItemResponse) => {
          if (!resultData?.data?.blog) {
            return;
          }

          setSelectedBlogItem(resultData.data.blog);
        });
    };

    getBlogItem(props.id);
  }, []);
  return (
    <Layout>
      <article>
        {selectedBlogItem && (
          <div className="news-item">
            <h2>{selectedBlogItem.title}</h2>
            <div
              className="news-item__content top-spacing-big"
              dangerouslySetInnerHTML={{ __html: selectedBlogItem.rich.html }}
            />
          </div>
        )}
      </article>
    </Layout>
  );
};

export default NewsItemPage;

export const Head = () => <SEO title="Новинки цікавинки" />;
